import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ProjectInitDTO } from '@pulse/api/core';

export const loadInit = createAction('[Init-API] Load Init');

export const loadInitSuccess = createAction('[Init-API] Load Init Success', props<{ init: ProjectInitDTO }>());

export const loadInitFailure = createAction('[Init-API] Load Init Failure', props<{ error: HttpErrorResponse }>());
